import debugHelper from './debug'
import TipsList from '../config/TipsList'
import APP_CONFIG from '../config/App'

console.log('调试代码')

var tools = {
  //深拷贝方法
  getCopy: function (src) {
    // debugHelper.log(src)
    return JSON.parse(JSON.stringify(src))
  },

  BrowserType: function () {
    var ua = window.navigator.userAgent
    var isIE = window.ActiveXObject != undefined && ua.indexOf('MSIE') != -1
    var isFirefox = ua.indexOf('Firefox') != -1
    var isOpera = window.opr != undefined
    var isChrome = ua.indexOf('Chrome') && window.chrome
    var isSafari = ua.indexOf('Safari') != -1 && ua.indexOf('Version') != -1
    if (isIE) {
      return 'IE'
    } else if (isFirefox) {
      return 'Firefox'
    } else if (isOpera) {
      return 'Opera'
    } else if (isChrome) {
      return 'Chrome'
    } else if (isSafari) {
      return 'Safari'
    } else {
      return 'Unkown'
    }
  },

  /**
   * 开始事件列表处理消息
   * @param { * } msgbus 消息总线
   * @param { * } vm 发出消息的对象
   * @param { * } funcList 处理消息的事件列表
   */
  startFuncList: function (msgbus, vm, funcList) {
    debugHelper.log('startFuncList')
    debugHelper.log(vm)
    var funcListTmp = tools.getCopy(funcList)

    funcListTmp.forEach(func => {
      func.setParams = vm.mSetParams
      func.getResult = vm.mGetResult
      func.exceptionHandler = vm.mExceptionHandler
    })

    msgbus.$emit('main', {
      id: funcListTmp[0].funcName,
      vm: vm,
      funcList: funcListTmp
    })
  },

  /**
   *
   * @param { * } tips 消息提示
   */
  parseTips: function (tips) {
    debugHelper.log('tips')
    debugHelper.log(tips)
    var prefix = tips.prefix
    debugHelper.log('parseTips tips')
    debugHelper.log(tips.type)
    // 网络异常
    switch (tips.toString()) {
      case 'AxiosError: Network Error':
      case 'Error: Network Error':
        tips = TipsList[tips]
        return {
          color: tips.color,
          text: tips.text.cn,
          visible: tips.visible
        }
      case 'AxiosError: Request failed with status code 502':
      case 'Error: Request failed with status code 502':
        tips = TipsList[tips]
        return {
          color: tips.color,
          text: tips.text.cn,
          visible: tips.visible
        }
      case 'AxiosError: timeout of ' + APP_CONFIG.timeout + 'ms exceeded':
      case 'Error: timeout of ' + APP_CONFIG.timeout + 'ms exceeded':
        tips = TipsList['Error: timeout of ms exceeded'] // 转换错误形式，因为APP_CONFIG.timeout配置值可能会变动
        return {
          color: tips.color,
          text: tips.text.cn,
          visible: tips.visible
        }
    }

    // 消息预处理, 主要针对动态消息类型
    switch (tips.type) {
      // 服务端回馈错误
      case 'error':
        if (tips.response && tips.response.data) {
          debugHelper.log('prefix + tips.response.data.message')
          debugHelper.log(prefix + tips.response.data.message)

          var msg = tips.response.data.message
          tips = TipsList[prefix + tips.response.data.message]
          if (tips != null) {
            break
          }
          for (var tmp in TipsList) {
            if ((prefix + msg).includes(tmp)) {
              tips = TipsList[tmp]
              if (tmp === 'work:request to eds-svc error' || tmp === 'work:request to eds-pro error') {
                break
              }
              tips.params = (prefix + msg).split(tmp)[1]
              break
            }
          }
          // tips = TipsList[prefix + tips.response.data.message]
        }
        break
      // 本地客户端错误
      case 'localError':
      case 'warning':
      case 'success':
      case 'info':
        debugHelper.log(prefix + tips.text)
        tips = TipsList[prefix + tips.text]
        break
    }
    debugHelper.log('tpps')
    debugHelper.log(tips)
    if (tips && tips.text) {
      return {
        color: tips.color,
        text: tips.text.cn + (tips.params == null ? '' : tips.params),
        visible: tips.visible
      }
    } else {
      tips = TipsList[`${prefix}unknown error`] || TipsList['unknown error']

      return {
        color: tips.color,
        text: tips.text.cn,
        visible: tips.visible
      }
    }
  },
  /**
   *
   * @param { * } vm 显示提示的组件
   * @param { * } tips 消息提示
   */
  showTips: function (vm, tips) {
    tips = this.parseTips(tips)
    if (tips) {
      vm.setSnackBar({
        value: {
          color: tips.color,
          text: tips.text,
          visible: tips.visible
        }
      })
    }
  },
  showError: function (vm, error) {
    vm.setSnackBar({
      value: {
        color: 'error',
        text: error,
        visible: true
      }
    })
  },
  isPC: function () {
    var userAgentInfo = navigator.userAgent
    var Agents = new Array(
      'Android',
      'iPhone',
      'SymbianOS',
      'Windows Phone',
      'iPad',
      'iPod'
    )
    var flag = true
    for (var v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
        flag = false
        break
      }
    }
    return flag
  },
  isiPad: function () {
    var userAgentInfo = navigator.userAgent
    var flag = false
    if (userAgentInfo.indexOf('iPad') > 0) {
      flag = true
    }
    return flag
  },

  // 判断字符串是不是JSON
  isJSON: function (str) {
    if (typeof str == 'string') {
      try {
        JSON.parse(str)
        return true
      } catch (e) {
        debugHelper.log(e)
        return false
      }
    }
    debugHelper.log('It is not a string!')
  },

  /**
   * @param {Function} func
   * @param {number} wait
   * @param {boolean} immediate
   * @return {*}
   */
  debounce: function (func, wait, immediate) {
    let timeout, context, timestamp, result

    const later = function (args) {
      // 据上一次触发时间间隔
      const last = +new Date() - timestamp

      // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
      if (last < wait && last > 0) {
        timeout = setTimeout(later, wait - last, args)
      } else {
        timeout = null
        // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
        if (!immediate) {
          result = func.apply(context, args)
          if (!timeout) context = args = null
        }
      }
    }

    return function (...args) {
      context = this
      timestamp = +new Date()
      const callNow = immediate && !timeout
      // 如果延时不存在，重新设定延时
      if (!timeout) timeout = setTimeout(later, wait, args)
      if (callNow) {
        result = func.apply(context, args)
        context = args = null
      }

      return result
    }
  }
}

export default tools
